import { HttpClient, HttpParams } from '@angular/common/http';
// import { camelToSnake } from 'oh-my-case';
import { camelCase } from '../rxjs';

const { camelToSnake } = require('oh-my-case');

export class Api {
  constructor(public httpClient: HttpClient, public path: string) {}

  idPath(id: any) {
    return `${this.path}/${id}`;
  }

  query(params?: any, options?: any) {
    if (params) {
      params = this.convert(params, options);
    }
    return this.httpClient.get<any>(this.path, { params }).pipe(camelCase());
  }

  get(id: any, params?: any, options?: any) {
    if (params) {
      params = this.convert(params, options);
    }
    return this.httpClient.get<any>(this.idPath(id), { params }).pipe(camelCase());
  }

  create(record: any, options = {}) {
    return this.httpClient.post<any>(this.path, this.convert(record, options), options).pipe(camelCase());
  }

  update(id: any, record: any, options = {}) {
    return this.httpClient.patch<any>(this.idPath(id), this.convert(record, options), options).pipe(camelCase());
  }

  delete(id: any) {
    return this.httpClient.delete<any>(this.idPath(id));
  }

  snakecaseKeys(record: any) {
    if (record instanceof FormData) {
      return this.snakecaseKeysOfFormData(record);
    }
    if (record instanceof HttpParams) {
      return this.snakecaseKeysOfHttpParams(record);
    }
    const newRecord: any = {};
    Object.keys(record).forEach((k) => {
      newRecord[camelToSnake(k)] = record[k];
    });
    return newRecord;
  }

  private snakecaseKeysOfFormData(record: FormData) {
    const formData = new FormData();
    record.forEach((v, k) => {
      formData.append(camelToSnake(k), v);
    });
    return formData;
  }

  private snakecaseKeysOfHttpParams(record: HttpParams) {
    let httpParams = new HttpParams();
    record.keys().forEach((k) => {
      record.getAll(k).forEach((v) => {
        httpParams = httpParams.append(camelToSnake(k), v);
      });
    });
    return httpParams;
  }

  private convert(record: any, options: any = {}) {
    return options.convert === undefined || options.convert ? this.snakecaseKeys(record) : record;
  }
}
